import { Breakpoint, NextBreakpointDecreaseStep, } from '../Breakpoint/Breakpoint';
export function join() {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    return parts.join(' ');
}
export function getMinWidth(breakpoint) {
    return "(min-width: " + Breakpoint[breakpoint] + "px)";
}
export function getMaxWidth(breakpoint) {
    return "(max-width: " + (Breakpoint[breakpoint] - NextBreakpointDecreaseStep) + "px)";
}
//# sourceMappingURL=utils.js.map